import React, { useMemo } from 'react';
import FinancialStatementTable from './FinancialStatementTable';
import {
    buildBalanceSheetStatementRows,
    evaluateBalanceSheetBalance,
    isBalanceSheetSectionCollapsible,
    isBalanceSheetStatementRowVisible,
} from '../config/balanceSheetStatementLayout';

const DEFAULT_EXPANDED = {
    borrowings: true,
    otherLiabilities: true,
    fixedAssets: true,
    otherAssets: true,
    tradeReceivables: true,
};

function BalanceCheckBanner({ result }) {
    if (!result || result.comparedCount === 0) return null;

    if (result.balanced) {
        return (
            <p className="cfs-balance-check cfs-balance-check--ok">
                Total Liabilities equal Total Assets in every column.
            </p>
        );
    }

    return (
        <p className="cfs-balance-check cfs-balance-check--warn">
            Total Liabilities and Total Assets differ in {result.mismatchedYears.join(', ')}.
        </p>
    );
}

function BalanceSheetStatementTable({ data, orderedKeys = [], headers = [], onMetricInfo, onOpenChart }) {
    const balance = useMemo(
        () => evaluateBalanceSheetBalance(data, orderedKeys),
        [data, orderedKeys],
    );

    return (
        <FinancialStatementTable
            title="Balance Sheet Statement"
            data={data}
            orderedKeys={orderedKeys}
            headers={headers}
            onMetricInfo={onMetricInfo}
            onOpenChart={onOpenChart}
            buildRows={buildBalanceSheetStatementRows}
            isSectionCollapsible={isBalanceSheetSectionCollapsible}
            isRowVisible={isBalanceSheetStatementRowVisible}
            defaultExpanded={DEFAULT_EXPANDED}
            statementKey="balanceSheet"
            banner={<BalanceCheckBanner result={balance} />}
        />
    );
}

export default BalanceSheetStatementTable;
